import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedOrgId: null,
  selectedOrgName: "",
  orgs: [],
};

const orgSelectSlice = createSlice({
  name: 'orgSelect',
  initialState,
  reducers: {
    setSelectedOrg(state, action) {
      state.selectedOrgId = action.payload;
      state.selectedOrgName = (state.orgs.find((org) => org.id === action.payload)?.name) || "";
    },
    setOrgList(state, action) {
      state.orgs = action.payload;
    },
    clearOrg(state) {
      state.selectedOrgId = null;
      state.selectedOrgName = "";
      state.orgs = [];
    },
  },
});

export const { setSelectedOrg, setOrgList, clearOrg } = orgSelectSlice.actions;
export default orgSelectSlice.reducer;
